import { Form, InputOnChangeData } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";

export interface FormData {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  repeatPassword: string;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
}

const AdminUserAddForm = ({ formData, onChange, formErrors, errors }: Props) => {
  const handleChange = (e: any, { name, value }: InputOnChangeData) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="2">
          <Form.Field required>
            <label>Email</label>
            <Form.Input error={formErrors.email} name="email" value={formData.email} onChange={handleChange} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>First Name</label>
            <Form.Input
              error={formErrors.firstName}
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field required>
            <label>Last Name</label>
            <Form.Input error={formErrors.lastName} name="lastName" value={formData.lastName} onChange={handleChange} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Password</label>
            <Form.Input
              error={formErrors.password}
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </Form.Field>
          <Form.Field required>
            <label>Repeat Password</label>
            <Form.Input
              error={formErrors.repeatPassword}
              type="password"
              name="repeatPassword"
              value={formData.repeatPassword}
              onChange={handleChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AdminUserAddForm;
